import createRequestAuth, {createRequestGeneric} from "../helpers/RequestHelper";

export const apiAuth = createRequestAuth();
export const api = createRequestGeneric();



// WEBPACK FOOTER //
// ./src/services/ApiService.js